import React, { useState } from "react";
import Chart from "react-google-charts";
import { Divider } from "antd";
import IndicadoresDetalhe from "./IndicadoresDetalhe";
import style from "./PieGraphInd.module.scss";
import { BarChart, CartesianGrid, XAxis, Tooltip, Bar, ResponsiveContainer } from "recharts";
import toLocale from "../../utils/ToLocaleString";
function PieGraphInd({ dados, title, subTitle, icon, ...props }) {
  const [detalhe, setDetalhe] = useState(null);

  return (
    <>
      <div className={style.mainWrapper}>
        <div style={{ width: "100%", display: "flex", alignItems: "center", color: "#ddd" }}>
          {icon}
          <div style={{ width: "100%" }}>
            <h1 style={{ margin: "0 10px", textAlign: "center", color: "#707070" }}>{title}</h1>
            <h4 style={{ margin: "0 10px", textAlign: "center", color: "#333" }}>{subTitle}</h4>
          </div>
        </div>
        {!!dados.porc.fornecedorLoja.valorComparador && (
          <div onClick={() => setDetalhe("forLoja")}>
            <Divider style={{ margin: 0 }} />
            {props.tipo === "pizza" ? (
              <PieGraphPizza
                porcent={dados.porc.fornecedorLoja.referencia}
                atual={{ nome: "Fabricante", dados: dados.fornecedor, porc: dados.porc.fornecedorLoja.valorReferencia }}
                comparativo={{ nome: "Loja", dados: dados.loja, porc: dados.porc.fornecedorLoja.valorComparador }}
                id={dados.id}
              />
            ) : (
              <PieGraph
                porcent={dados.porc.fornecedorLoja.referencia}
                atual={{ nome: "Fabricante", dados: dados.fornecedor, porc: dados.porc.fornecedorLoja.valorReferencia }}
                comparativo={{ nome: "Loja", dados: dados.loja, porc: dados.porc.fornecedorLoja.valorComparador }}
                id={dados.id}
              />
            )}
          </div>
        )}
        {!!dados.porc.setorLoja.valorComparador && (
          <div onClick={() => setDetalhe("setLoja")}>
            <Divider style={{ margin: 0 }} />
            {props.tipo === "pizza" ? (
              <PieGraphPizza
                porcent={dados.porc.setorLoja.referencia}
                atual={{ nome: "Setor/Grupo", dados: dados.setor, porc: dados.porc.setorLoja.valorReferencia }}
                comparativo={{ nome: "Loja", dados: dados.loja, porc: dados.porc.setorLoja.valorComparador }}
                id={dados.id}
              />
            ) : (
              <PieGraph
                porcent={dados.porc.setorLoja.referencia}
                atual={{ nome: "Setor/Grupo", dados: dados.setor, porc: dados.porc.setorLoja.valorReferencia }}
                comparativo={{ nome: "Loja", dados: dados.loja, porc: dados.porc.setorLoja.valorComparador }}
                id={dados.id}
              />
            )}
          </div>
        )}
        {!!dados.porc.fornecedorSetor.valorComparador && (
          <div onClick={() => setDetalhe("forSet")}>
            <Divider style={{ margin: 0 }} />
            {props.tipo === "pizza" ? (
              <PieGraphPizza
                porcent={dados.porc.fornecedorSetor.referencia}
                atual={{ nome: "Fabricante", dados: dados.fornecedor, porc: dados.porc.fornecedorSetor.valorReferencia }}
                comparativo={{ nome: "Setor/Grupo", dados: dados.setor, porc: dados.porc.fornecedorSetor.valorComparador }}
                id={dados.id}
              />
            ) : (
              <PieGraph
                porcent={dados.porc.fornecedorSetor.referencia}
                atual={{ nome: "Fabricante", dados: dados.fornecedor, porc: dados.porc.fornecedorSetor.valorReferencia }}
                comparativo={{ nome: "Setor/Grupo", dados: dados.setor, porc: dados.porc.fornecedorSetor.valorComparador }}
                id={dados.id}
              />
            )}
          </div>
        )}
      </div>
      <IndicadoresDetalhe onCancel={() => setDetalhe(null)} detalhe={detalhe} filtros={dados.filtros} />
    </>
  );
}

export default PieGraphInd;

function PieGraphPizza({ porcent, atual, comparativo }) {
  const colors = ["#ff8000", "#4791db"];
  return (
    <div className={style.wrapper}>
      <h2 className={style.porcent}>{porcent.toFixed(2)}%</h2>
      <Chart
        width="100%"
        chartType="PieChart"
        loader={<div>Loading Chart</div>}
        data={[
          ["Task", "Fornecedor x Setor"],
          [atual.dados, atual.porc],
          [comparativo.dados, comparativo.porc],
        ]}
        options={{
          pieStartAngle: 50,
          is3D: true,
          pieSliceText: "none",
          colors,
          legend: "none",
          tooltip: {
            trigger: 'none'
          }
        }}

        rootProps={{ "data-testid": "2" }}
      />
      <h3>
        <span style={{ color: "#ff8000" }}>{atual.nome}</span> x <span style={{ color: "#4791db" }}>{comparativo.nome}</span>
      </h3>
    </div>
  );
}

function PieGraph({ porcent, atual, comparativo }) {
  return (
    <div className={style.wrapper}>
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <h2 style={{ color: "#ff8000" }}>{toLocale(atual.porc)}</h2>
        <h2>{toLocale(comparativo.porc)}</h2>
      </div>
      <ResponsiveContainer>
        <BarChart
          style={{ cursor: "pointer" }}
          data={[{ atual: atual.porc, comparativo: comparativo.porc }]}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <Tooltip />
          <Bar name={atual.nome} dataKey="atual" fill="#ff8000" />
          <Bar name={comparativo.nome} dataKey="comparativo" fill="#4791db" />
        </BarChart>
      </ResponsiveContainer>
      <h3>
        <span style={{ color: "#ff8000" }}>{atual.nome}</span> x <span style={{ color: "#4791db" }}>{comparativo.nome}</span>
      </h3>
    </div>
  );
}
